const messages = {
  en: {
    "card-description-bold": "Ready to simplify your bookkeeping?",
    "card-description":
      "Connect your Moneris account with QuickBooks Online in just a few steps and make managing your sales and financial data easier—without extra manual work.",
    "card-button": "Get started",
    "card-title": "Quickbooks Online",
    "card-footnote-link": "https://www.moneris.com/en/legal/offer-details/quickbooks_connector",
  },
  fr: {
    "card-description-bold": "Vous souhaitez simplifier votre comptabilité?",
    "card-description":
      "Liez votre compte Moneris à QuickBooks en ligne en quelques étapes et gérez vos données liées aux ventes et aux finances plus facilement, sans manipulation supplémentaire.",
    "card-button": "Commencer",
    "card-title": "QuickBooks en ligne",
    "card-footnote-link": "https://www.moneris.com/fr-ca/juridiques/details-de-loffre/quickbooks_connector",
  },
};

export default messages;

